import { defineComponent } from 'vue';
import DisclosureFooter from '~/components/members-area/DisclosureFooter.vue';
export default defineComponent({
  name: 'MLANoticeSection',
  components: {
    DisclosureFooter
  },
  emits: ['continue']
});